import styled, { css } from 'styled-components';

import { colorScheme } from '../../theme';

export const TabsContainer = styled.div<{ manualJustify?: boolean }>`
  background: ${colorScheme.tabs.background};
  width: 100%;
  border: none;
  font-size: 14px;

  .nav-tabs .nav-link {
    // TODO - it's fallback. Delete if you're sure everything looks good.
    ${({ manualJustify }) =>
      manualJustify &&
      css`
        width: 100%;
        max-width: 50%;
        max-width: calc(100% / 2);
      `}

    background: ${colorScheme.globalBackground};
    border: none;
    border-bottom: 1px solid ${colorScheme.globalBackground};

    border-radius: 0;
    text-align: center;
    font-weight: 600;
    color: ${colorScheme.text.base};
    transition: 300ms linear background;

    &:last-of-type {
      border-right: 0 !important;
    }

    &:active,
    &:hover,
    &:focus {
      outline: none;
      border: none;
      box-shadow: none;
      border-bottom: 1px solid ${colorScheme.divider};
    }

    &.active {
      background: ${colorScheme.tabs.active};
      border: 0;
    }
  }

  .nav-tabs .nav-item {
    width: 100%;
    max-width: 50%;
    max-width: calc(100% / 2);
  }

  .nav-tabs a.nav-link {
    max-width: 100%;
    width: auto;
  }

  .tab-pane {
    padding: 6%;
    font-weight: 300;
    line-height: 1;

    table td:first-of-type {
      width: 50%;
    }

    table td:nth-of-type(2) {
      padding-left: 0;
    }
  }

  table tr td {
    padding-top: 1em;
    padding-bottom: 1em;
  }

  table tr td:nth-of-type(2) {
    font-weight: 600;
  }
`;
